
import { Account } from './../interfaces/account.model';
import { ApiService } from './../services/api.service';
import { ResponseService } from './../services/response.service';
import { Component, OnInit } from '@angular/core';
import { Logon } from './../interfaces/logon.model';

@Component({
  selector: 'logon-account',
  templateUrl: './logon-account.component.html',
})
export class LogonAccountComponent implements OnInit {

  loadingLogons : Boolean = true;
  logons : Array<Logon>;
  p: number = 1;


  constructor(
    private apiService: ApiService,
    private responseService: ResponseService
  ) { }

  ngOnInit() {

    this.apiService.get('/logons').subscribe(
      (response) => {
        this.logons = this.responseService.success(false, response, 'logons');
        this.loadingLogons = false;
      },
      (error) => {
        this.responseService.error(error);
      }
      
    );
    
  }

  
}



// WEBPACK FOOTER //
// ./src/app/account/logon-account.component.ts